import React, {useContext, useState} from 'react';
import moment from "moment";
import __ from "lodash";
import {Grid, Icon, IconButton, Tooltip, Typography} from "@material-ui/core";

import SystemContext from "../../../SystemContext";
import {FormDialog} from "../../../controls";

import {useLastAircraftMovement, useAddAircraftMovement, useDeleteLastAircraftMovement} from "../../../services/aircraft";

const parseFlightNumber = (flightNumber) => {
  const flightParts = flightNumber.match(/[0-9]?[A-Z]{1,2}([0-9]{3,4}[A-Z]?)/) || [""];
  const flightNo = flightParts.length > 1 ? flightParts[1] : flightParts[0];
  const airlineCode = flightNumber.replace(flightNo, "");

  return {flightNo, airlineCode}
}


const AircraftDeleteLastMovementDialog = (props) => {

  const classes = props.classes;
  const SystemData = useContext(SystemContext);

  const now = moment.utc();
  const minDate = moment.utc().subtract(6, 'month');
  const maxDate = moment(minDate).add(3, 'year');
  const initialDate = now.toISOString();
  const dateFormat = "DD/MM/YYYY";

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {etd: initialDate},
    handleSave: null
  });
debugger;
  const _airlineCode = props.airlineCode;
  const _flightNo = props.flightNo;
  const originAirportCode = props.originAirportCode;
  const destinationAirportCode = props.destinationAirportCode;
  const tripLegUuid = props.tripLegUuid;
  const aircraftTailNumber = props.aircraftTailNumber;

  const [movementRecord, setMovementRecord] = useState(null);

  const handleDeleteMovement = useDeleteLastAircraftMovement();

  const extraKeys = tripLegUuid ? [props.aircraftTailNumber, tripLegUuid] : [props.aircraftTailNumber];
  const lastMovement = useLastAircraftMovement({extraKeys});
  if (lastMovement && __.has(lastMovement, "status") && lastMovement.status === "success" && !movementRecord) {
    let data = {
      movementType: "SUMMARY",
      flightNumber: ""
    }
    if (lastMovement.data) {
      data = lastMovement.data;
    }
    const movementType = data.movementType === 'RETURN-TO-STAND'?'SUMMARY':data.movementType;
    const {flightNo, airlineCode} = parseFlightNumber(data.flightNumber);
    // const nextMovementType = movementType === "SUMMARY" && tripLegUuid ? "SUMMARY" : allTypes[allTypes.indexOf(movementType) + 1];
    const newMovement = {
      lastMovementType: data.movementType,
      lastAirlineCode: airlineCode,
      lastFlightNo: flightNo,
      lastFlightDate: data.flightDateUTC,
      lastOrigin: data.originAirportCodeIata,
      lastDestination: data.destinationAirportCodeIata,
      aircraftTailNumber: props.aircraftTailNumber,
      // movementType: nextMovementType,
      flightNumber: movementType !== "SUMMARY" ? data.flightNumber : `${_airlineCode}${_flightNo}`||"",
      airlineCode: movementType !== "SUMMARY" ? airlineCode : _airlineCode||"",
      flightNo: movementType !== "SUMMARY" ? flightNo : _flightNo||"",
      flightDateUTC: movementType !== "SUMMARY" ? data.flightDateUTC : "",
      originAirportCodeIata: movementType !== "SUMMARY" ? data.originAirportCodeIata : originAirportCode||"",
      originAirportCodeIcao: movementType !== "SUMMARY" ? data.originAirportCodeIcao : "",
      destinationAirportCodeIata: movementType !== "SUMMARY" ? data.destinationAirportCodeIata : destinationAirportCode||"",
      destinationAirportCodeIcao: movementType !== "SUMMARY" ? data.destinationAirportCodeIcao : "",
      offBlocksTimeUTC: data.offBlocksTimeUTC ? data.offBlocksTimeUTC : initialDate,
      takeOffTimeUTC: data.takeOffTimeUTC ? data.takeOffTimeUTC : null,
      landingTimeUTC: data.landingTimeUTC ? data.landingTimeUTC : null,
      onBlocksTimeUTC: data.onBlocksTimeUTC ? data.onBlocksTimeUTC : null,
      etaUTC: data.etaUtc ? data.etaUtc : null,
      upliftFuelKg: 0,
      movementFuelKg:	0,
      emailUuid: null,
      processedUTC: null,
      processedStatus: null,
      lastMovement: lastMovement.data,
      tripLegUuid: tripLegUuid
    }

    setMovementRecord(newMovement);
  }

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left" }}>
    {movementRecord
      ?
        <FormDialog
          title={props.title}
          message={lastMovement.data?`Last recorded movement: ${__.capitalize(movementRecord.lastMovementType).replace(/-/g,' ')} of flight ${movementRecord.lastAirlineCode}-${movementRecord.lastFlightNo} (${movementRecord.lastOrigin}-${movementRecord.lastDestination}) on ${moment(movementRecord.lastFlightDate).format(dateFormat)}`:''}
          open={props.open}
          record={movementRecord}
          dialogOptions={{maxWidth: "sm", fullWidth: false}}
          movable={true}
          classes={classes}
          // validator={Validator}
          buttons = {{
            save:{icon: "check_circle", key: "Delete", label: "Delete", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              SystemData.toggleLoadingProgress(true);

              handleDeleteMovement.mutate({
                aircraftTailNumber: aircraftTailNumber,
                postSuccess: (result) => {
                  SystemData.toggleLoadingProgress(false);
                  props.onChange();
                },
                postError: (data) => {
                  SystemData.toggleLoadingProgress(false);
                  if (data.errorMessage) {
                    if (__.has(data.errorMessage, "response") &&
                        __.has(data.errorMessage.response, "data") &&
                        __.has(data.errorMessage.response.data, "errorMessage") &&
                        data.errorMessage.response.data.errorMessage !== "") {
                      const actualError = data.errorMessage.response.data.errorMessage;
                      SystemData.alert("Error", actualError);
                    } else {
                      SystemData.alert("Error", `An Unexpected Error has occurred saving the Movement. ${data.errorMessage}`);
                    }
                  } else {
                    SystemData.alert("Error", `An Unexpected Error has occurred saving the Movement`);
                  }
                }
              });
            } else {
              setMovementRecord(null);
              props.onChange();
            }
          }}
        >
          <div style={{marginBottom: 20}}></div>


        </FormDialog>
      :
        <></>
    }
    </div>
  )
}

export default AircraftDeleteLastMovementDialog;
